import $ from "jquery";
import React, { Suspense, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PostLoginGetApi from '../../../../components/Api/PostLoginGetApi';
import BankAccountDetails from './BankAccountDetails';
import ContactInfo from './ContactInfo';
import DocumentList from './DocumentList';
import PartnerInfo from './PartnerInfo';
import PartnerRegistrationInfo from './PartnerRegistrationInfo';
import KamInfo from "./KamInfo";
import UserBasicInfoContext from "../../../../components/Context/UserBasicInfoContext";
import { useContext } from "react";
import { SUPER_ADMIN } from "../../ConstRole/ConstRole";

const CompanyDetails = () => {
    const [currentTab, setCurrentTab] = useState("partner-registration-info");
    const { id } = useParams();
    const profile = useContext(UserBasicInfoContext);


    const [companyDetails, setCompanyDetails] = useState([]);

    const handleTab = (tabId, event) => {
        $(".tablinks").removeClass("current");
        $(event.target).addClass("current");
        setCurrentTab(tabId);
    }

    useEffect(() => {

        // Company List
        PostLoginGetApi(`company/${id}`, "", 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setCompanyDetails(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        })
    }, []);

    return (
        <div className="custom-container w-full float-left px-8 py-10 pt-4 block font-montserrat custom-scroll-auto mb-20">

            <div className="tab w-full">
                <button className="tablinks current" onClick={(event) => handleTab("partner-registration-info", event)}>Registration Info</button>
                <button className="tablinks " onClick={(event) => handleTab("bank-account-details", event)}>Bank Account</button>
                <button className="tablinks" onClick={(event) => handleTab("partner-info", event)}>Partner's Info</button>
                <button className="tablinks" onClick={(event) => handleTab("contact-info", event)}>Contact Info</button>
                <button className="tablinks" onClick={(event) => handleTab("document-list", event)}>Document List</button>
                {profile?.user_type === SUPER_ADMIN &&
                    <button className="tablinks" onClick={(event) => handleTab("kam-info", event)}>Kam Info&nbsp;&nbsp;</button>
                }
            </div>

            <div className='tabcontentbody py-3'>
                <div id="view-profile" className="tabcontent" style={{ display: "block", paddingLeft: "0px" }}>
                    <Suspense fallback="Loading...">


                        {(() => {
                            switch (currentTab) {
                                case "partner-registration-info":
                                    return <PartnerRegistrationInfo companyDetails={companyDetails} />
                                case "bank-account-details":
                                    return <BankAccountDetails companyDetails={companyDetails} />
                                case "partner-info":
                                    return <PartnerInfo companyDetails={companyDetails} />
                                case "contact-info":
                                    return <ContactInfo companyDetails={companyDetails} />
                                case "document-list":
                                    return <DocumentList companyDetails={companyDetails} />
                                case "kam-info":
                                    return <KamInfo companyDetails={companyDetails} />
                                default:
                                    return <h1>No page found.</h1>
                            }
                        })()}



                    </Suspense>
                </div>
            </div>


        </div>
    );
};

export default CompanyDetails;